import ExcelJS from 'exceljs';

export default class ProductosAYBExcel {

  static generateWorkbook(data) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Productos AYB');

    // Definir los encabezados para la tabla
    const headers = [
      { header: 'Código', key: 'Codigo', type: 'number' },
      { header: 'Receta ID', key: 'RecetaId' },
      { header: 'Receta', key: 'Receta' },
      { header: 'Insumo ID', key: 'InsumoID' },
      { header: 'Insumo', key: 'Insumo' },
      { header: 'Departamento', key: 'Departamento' },
      { header: 'Categoría', key: 'Categoria' },
      { header: 'Familia', key: 'Familia' },
      { header: 'Etiquetas', key: 'Etiquetas' },
      { header: 'Costo', key: 'Costo', type: 'number' },
      { header: 'Moneda Costo', key: 'MonedaCosto' },
      { header: 'Precio', key: 'Precio', type: 'number' },
      { header: 'Moneda', key: 'Moneda' }
    ];

    // Calcular la última columna
    const lastColLetter = String.fromCharCode(64 + headers.length);

    // Agregar una fila de título (fusionando las celdas)
    worksheet.mergeCells(`A1:${lastColLetter}1`);
    const titleCell = worksheet.getCell('A1');
    titleCell.value = 'Productos AYB';
    titleCell.font = { bold: true, size: 18 };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB0C4DE' } // LightSteelBlue
    };

    // Dejar una fila en blanco para separar el título de los encabezados
    worksheet.addRow([]);

    // Agregar la fila de encabezados de la tabla
    const headerRow = worksheet.addRow(headers.map(h => h.header));
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFADD8E6' } // LightBlue
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Agregar las filas de datos
    data.forEach(item => {
      const etiquetas = Array.isArray(item.Etiquetas)
        ? item.Etiquetas.join(', ')
        : item.Etiquetas;

      const rowData = headers.map(header => {
        let value = item[header.key];

        // Convertir a número si la columna requiere un valor numérico
        if (header.type === 'number') {
          value = value ? Number(value) : 0; // Asegurar conversión a número
        }

        return value;
      });

      const row = worksheet.addRow(rowData);
      row.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Autoajustar el ancho de las columnas según el contenido
    worksheet.columns.forEach((column) => {
      let maxLength = column.width || 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellText = cell.value ? cell.value.toString() : '';
        if (cellText.length > maxLength) {
          maxLength = cellText.length;
        }
      });
      column.width = maxLength + 2; // Se agrega padding extra
    });

    return workbook;
  }

  static async generateExcelBuffer(data) {
    const workbook = ProductosAYBExcel.generateWorkbook(data);
    return await workbook.xlsx.writeBuffer();
  }
}
